import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrapper from './App.js'; // Explicitly add `.js` extension
import reportWebVitals from './reportWebVitals.js'; // Explicitly add `.js` extension
import { AuthProvider } from 'react-oidc-context';
import { createOidcConfig } from './oidcConfig.js';

// OIDC Configuration for AWS Cognito (user kept in localStorage - oidcConfig.js)
const oidcConfig = createOidcConfig();


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <AppWrapper />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals(console.log);
